<template>
  <div>
    <div class="onboarding-flex" v-if="showLoader">
      <div>
        <BouncingLoader />
      </div>
    </div>
    <div class="row row-space-4" v-else>
      <div class="col-md-6">
        <div class="p-4">
          <img src="@/assets/img/done.svg" class="img-fluid" />
        </div>
      </div>
      <div class="col-md-6 align-self-center">
        <h1 class="h3 mb-1">Congratulations 🎉</h1>
        <h1 class="h3">
          <span v-if="pagespeed">
            Your store is now
            <span class="em-line">{{pagespeed.change}}%</span>
            faster on mobile!
          </span>
          <span v-else>You have successfully completed the setup!</span>
        </h1>

        <div v-if="pagespeed" class="mb-5">
          <p class="lead mb-5">Here is the Google PageSpeed Insights summary of your AMP compared to your normal pages.</p>

          <PageSpeed :result="pagespeed.result" />

          <p class="small mt-1 text-center text-muted">This report is also available on the Reports page.</p>
        </div>

        <div>
          <p class="lead">Your AMP store is ready. You can customize it further or enable it right away!</p>
          <Streak class="active mr-3">
            <button class="btn btn-primary" @click="enable" :disabled="!canClick">Enable &amp; Continue</button>
          </Streak>
          <a class="btn btn-link pl-0" @click="skip" :disabled="!canClick">Skip to Dashboard</a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions } from 'vuex'

import PageSpeed from '@/components/PageSpeed'
import BouncingLoader from '@/components/BouncingLoader'
import Streak from '@/components/Streak'

import filters from '@/mixins/filters'
import mapMultiComputed from '@/mixins/mapMultiComputed'
import watchForChange from '@/mixins/watchForChange'

export default {
  mixins: [
    filters,
    watchForChange(),
    mapMultiComputed('settings', [
      'status.amp'
    ])
  ],
  components: {
    PageSpeed,
    BouncingLoader,
    Streak
  },
  computed: {
    ...mapState([ 'shopObj' ]),
    showLoader: function () {
      if (this.shopObj.password_enabled === false && this.pagespeed === null) return true

      return false
    }
  },
  data: function () {
    return {
      pagespeed: null,
      canClick: true
    }
  },
  created: async function () {
    this.loadedAt = Date.now()

    if (this.shopObj.password_enabled) {
      this.pagespeed = false
      this.$store.commit('FINAL_STEP')
      return
    }

    this.getPageSpeedData()
  },
  methods: {
    ...mapActions([ 'saveMaster' ]),
    enable: async function () {
      if (!this.canClick) return

      this.canClick = false
      this.status__amp = true

      await this.$nextTick()
      await this.saveMaster(true)
      await this.$nextTick()

      this.next()
    },
    skip: async function () {
      if (!this.canClick) return

      this.canClick = false
      await this.saveMaster(true)

      this.next()
    },
    next: function () {
      this.$router.replace({ name: 'home' })
    },
    getPageSpeedData: async function () {
      if (this.pagespeed === false) return

      const pagespeed = await this.$API_GET('/pagespeed')

      if (pagespeed.success) {
        this.pagespeed = pagespeed
      } else {
        this.pagespeed = false
      }

      this.$store.commit('FINAL_STEP')
    }
  }
}
</script>
